/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */
(function (Flickity) {
  // Hero Section Script Start
  const heroSliderSlides = document.querySelectorAll('.hero-slider .hero-img-wrapper');
  if(heroSliderSlides && heroSliderSlides.length > 1) {
    new Flickity( '.hero-slider', {
      wrapAround: true,
      prevNextButtons: false,
      autoPlay: true,
      cellAlign: 'right'
    });
  }
  // Hero Section Script End

  // Product Slider Script Start
  const equalizeCellHeights = () => {
    const cells = document.querySelectorAll('.product-slider .pdp-slide-item');
    let maxHeight = 0;
    cells.forEach(cell => {
      cell.style.height = 'auto';
      if (cell.offsetHeight > maxHeight) {
        maxHeight = cell.offsetHeight;
      }
    });
    cells.forEach(cell => {
      cell.style.height = maxHeight + 'px';
    });
  }

  const productSliderslides = document.querySelectorAll('.product-slider .pdp-slide-item');

  if(productSliderslides && productSliderslides.length > 1) {
    new Flickity('.product-slider', {
        wrapAround: true,
        cellAlign: 'left',
        adaptiveHeight: false,
        on: {
          ready: function() {
            equalizeCellHeights()
          }
        }
      });
  }

  // Product Slider Script End

  // Featured Collection Script Start
  const cfcSliderSlides = document.querySelectorAll('.cfc-pdp-slider .cfc-grid-item')
  if(cfcSliderSlides && cfcSliderSlides.length > 1) {
    new Flickity( '.cfc-pdp-slider', {
      wrapAround: true,
      cellAlign: 'left',
      adaptiveHeight: false,
      on: {
        ready: function() {
          equalizeCellHeights()
        }
      }
    });
  }
  // Featured Collection Script End

  document.addEventListener("DOMContentLoaded", function () {

    // Product Detail Page Variant as a dropdown
    const collapseBtn = document.getElementById("custom-collapse-btn");
    const ymqBox = document.getElementById("ymq-box");

    if(collapseBtn && ymqBox) {
      collapseBtn.addEventListener("click", function () {
        if (ymqBox.style.display === "none" || getComputedStyle(ymqBox).display === "none") {
          ymqBox.style.display = "block";
        } else {
          ymqBox.style.display = "none";
        }
      });
    }

    const variants = document.querySelectorAll("[name='options[Color]']");
    if (variants.length > 0) {
      variants.forEach(variant => {
        variant.addEventListener('change', () => {
          const currentVariant = variant;
          const colorLegend = document.getElementById('currentColorSwatch');
          if(colorLegend){
            colorLegend.textContent = currentVariant.value
          }

          const variantSliderImages = document.querySelectorAll('div.variant-image');

          if(variantSliderImages) {
            variantSliderImages.forEach((image) => {
              if(!image.classList.contains('hidden')) {
                image.classList.add('hidden');
              }
              if(image.dataset.variant === currentVariant.value) {
                image.classList.remove('hidden');
              }
            });
          }
        })
      });
    }


    // Product Tabs Script Start
    const tabButtons = document.querySelectorAll(".sfyn-pdp-tabs-wrapper li a");
    const tabItems = document.querySelectorAll(".sfyn-tab-item");

    tabButtons.forEach(function (tabButton) {
      tabButton.addEventListener("click", function (e) {
        e.preventDefault();
        tabButtons.forEach(function (button) {
          button.classList.remove("sfyn-active-tab-btn");
        });
        tabButton.classList.add("sfyn-active-tab-btn");

        const target = tabButton.getAttribute("data-url");
        tabItems.forEach(function (tabItem) {
          if (tabItem.getAttribute("data-url-target") === target) {
            tabItem.style.display = "block";
          } else {
            tabItem.style.display = "none";
          }
        });
      });
    });

    if (tabButtons.length > 0) {
      tabButtons[0].click();
    }

 const addToCartBtn = document.querySelector('.add-to-cart-button');
  if(addToCartBtn) {
    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent page refresh

      var productId = document.querySelector('input[name="id"]').value; // The product variant ID

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          updateCartCount(); // Update the cart count after adding to cart
        });
    });
    // Function to update the cart count
    function updateCartCount() {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          const cartCount = cart.item_count;
          document.querySelector(".mycart-quantity").textContent = cartCount; // Update the cart count in the DOM
        });
    }
  }

  });




})(themeVendor.Flickity);
